export const noSpecialChars = {
  name: 'noSpecialChars',
  option: {
    inserted: function (el) {
      el.addEventListener('input', function (e) {
        const newVal = e.target.value.replace(/[&;]/g, '');
        if (newVal !== e.target.value) {
          e.target.value = newVal;
          // 触发 input 事件以更新 Vue 的数据绑定
          e.target.dispatchEvent(new Event('input'));
        }
      });
    },
    update: function (el) {
      el.addEventListener('input', function (e) {
        const newVal = e.target.value.replace(/[&;]/g, '');
        if (newVal !== e.target.value) {
          e.target.value = newVal;
          // 触发 input 事件以更新 Vue 的数据绑定
          e.target.dispatchEvent(new Event('input'));
        }
      });
    }
  }
};
